import type { ProfitabilityReport } from "@/profitability/types";
import { SettingsGroup, SettingsRow } from "./settings-group";

const purpose = (report: ProfitabilityReport) => {
  const text = report.description?.trim();
  if (!text) return "A job costing report built from the source files below.";
  const sentence =
    text.match(/^.*?[.!?](?:\s|$)/s)?.[0].trim() ?? text.split("\n")[0];
  return sentence.length > 240
    ? `${sentence.slice(0, 237).replace(/\s+\S*$/, "")}…`
    : sentence;
};

export const AgentSummary = ({ report }: { report: ProfitabilityReport }) => (
  <SettingsGroup title="Agent">
    <SettingsRow label="Name" value={report.name} />
    <SettingsRow label="About" value={purpose(report)} />
  </SettingsGroup>
);
